export interface OpenedToasterInfo {
    rootElement: HTMLElement;
    bodyElement: HTMLElement;
    settings: any;
}

export class ToasterHandler {

    private _getToasterInfoCallback: () => OpenedToasterInfo;

    constructor(getToasterInfoCallback: () => OpenedToasterInfo) {
        this._getToasterInfoCallback = getToasterInfoCallback;
    }

    close() {
        //the parameters of hide() method are reversed in the TypeScript definition of iziToast
        import("izitoast").then(m => m.default).then((iziToast) => {
            const toasterInfo = this._getToasterInfoCallback();

            iziToast.hide(toasterInfo.settings, toasterInfo.rootElement as HTMLDivElement, 'toasterHandler');
        });
    }
}